import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ListRenderState from '../../../services/enums/listRenderState';
import styles from './style.scss';

export default class ListWrapper extends Component {

    render() {

        let content = null;

        if (this.props.listRenderState === ListRenderState.shouldRenderList) {
            
            content = this.props.header;
        }
        else {

            content = <div className={classNames(styles.listNoResultsWrapper)}>
                        <span>
                            {
                                this.props.listRenderState === ListRenderState.shouldRenderEmptyMessage
                                    ? this.props.translations.noEntries
                                        : this.props.translations.searchIconToSearchUsers
                            }
                        </span>
                     </div>;
        }

        return (
            <div>
                {content}
            </div>
        );
    }
}

PropTypes.propTypes = {
    listRenderState: PropTypes.number.isRequired,
    translations: PropTypes.shape({
        username: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        noEntries: PropTypes.string.isRequired,
        searchIconToSearchUsers: PropTypes.string.isRequired
    }).isRequired
};